<template>
  <div class="view">
    <template v-if="isSplash">
      <div class="splash">
        <div class="logo" id="logo">
          <img :src="require('./assets/logo.png').default" />
        </div>
        <div class="menu">
          <div class="corner corner-tl"></div>
          <div class="corner corner-tr"></div>
          <div class="corner corner-bl"></div>
          <div class="corner corner-br"></div>
          <span
            class="menu-item"
            id="innerLogo"
            style="display:none; text-align: center;"
            ><img :src="require('./assets/logo.png').default" width="120px"
          /></span>
          <a
            class="menu-item"
            @click="
              onStartGame('sam2_kor', 'KOEI.BAT', ['1', '2', '3', '4', '5'])
            "
            >삼국지2 한글판 플레이</a
          >
          <a
            class="menu-item"
            @click="
              onStartGame('sam2_eng', 'KOEI.BAT', ['1', '2', '3', '4', '5'])
            "
            >삼국지2 영문판 플레이</a
          >
          <a
            class="menu-item"
            @click="
              onStartGame('sam3', 'KOEI.COM', ['SANGOKU3.SAV', 'NBDATA.DAT'])
            "
            >삼국지3 플레이</a
          >
          <a
            class="menu-item"
            @click="
              onStartGame('sam4pk', 'sam4.bat', ['SAVEDAT.S4', 'NBDATA.S4'])
            "
            >삼국지4pk 플레이</a
          >
          <a
            class="menu-item"
            @click="
              onStartGame('hero', 'hero.com', [
                'MSAVE0.R3S',
                'ESAVE0.R3S',
                'MSAVE1.R3S',
                'ESAVE1.R3S',
                'MSAVE2.R3S',
                'ESAVE2.R3S',
                'MSAVE3.R3S',
                'ESAVE3.R3S',
                'MSAVE4.R3S',
                'ESAVE4.R3S',
              ])
            "
            >삼국지 영걸전 플레이</a
          >
          <a
            class="menu-item"
            @click="onStartGame('suho', 'koei.com', ['SAVEDATA'])"
            >수호전 플레이[비번:10000]</a
          >
          <a
            class="menu-item"
            @click="onStartGame('khan3', 'koei.com', ['SAVEDATA.GK2'])"
            >징기스칸3 플레이</a
          >
        </div>
        <span id="notice" style="color:white; padding: 10px;"
          >※ 삼국지2 에서 게임 저장하실 때 ("1" ~ "5")로 저장<br />
          ※ 삼국지4, 영걸전 - 마우스 가능<br />
        </span>
        <!-- <div class="menu">
          <template v-if="isLoginDbx === null">
            <a class="menu-item menu-item-with-icon">
              <img :src="require('./assets/icon-dropbox.svg').default" />
              <span>인증정보를 가져오는 중</span>
            </a>
          </template>
          <template v-else-if="!isLoginDbx">
            <a class="menu-item menu-item-with-icon" @click="onLoginDropbox">
              <img :src="require('./assets/icon-dropbox.svg').default" />
              <span>로그인</span>
            </a>
          </template>
          <template v-else>
            <a class="menu-item menu-item-with-icon" @click="onLogoutDropbox">
              <img :src="require('./assets/icon-dropbox.svg').default" />
              <span>로그아웃</span>
            </a>
          </template>
        </div> -->
      </div>
    </template>
    <template v-else>
      <Game
        :mod="gameMod || undefined"
        :entry="gameEntry || undefined"
        :save="gameSave || undefined"
        :dbx="dbx"
      />
    </template>
  </div>
</template>
<script lang="ts">
import { Dropbox, DropboxAuth } from "dropbox";
import Vue from "vue";

import Game from "./components/game.vue";
import { parseQueryString } from "./utils";

const version = require("../package.json").version; // eslint-disable-line @typescript-eslint/no-require-imports

//const DBX_CLIENT_ID = "95lb7zut06xyhr8";

export default Vue.extend({
  components: {
    Game,
  },
  data() {
    return {
      width: 640,
      height: 480,
      isSplash: true,
      gameMod: null as string | null,
      gameEntry: null as string | null,
      gameSave: null as string[] | null,
      dbx: null as Dropbox | null,
      isLoginDbx: null as boolean | null,
    };
  },
  async mounted() {
    this.preventBack();

    window.addEventListener("resize", this.onResize);
    this.onResize();

    // const dbxAccessToken =
    //   parseQueryString(location.hash).access_token ||
    //   window.localStorage.getItem("dbx_access_token") ||
    //   (null as string | null);
    // history.replaceState({}, "", location.href.replace(location.hash, ""));

    // if (dbxAccessToken) {
    //   const dbx = new Dropbox({ accessToken: dbxAccessToken });
    //   try {
    //     await dbx.usersGetCurrentAccount();
    //     window.localStorage.setItem("dbx_access_token", dbxAccessToken);
    //     this.dbx = dbx;
    //     this.isLoginDbx = true;
    //   } catch (e) {
    //     this.onLogoutDropbox();
    //   }
    // } else {
    //   this.isLoginDbx = false;
    // }
  },
  computed: {
    version() {
      return version;
    },
  },
  methods: {
    onStartGame(gameMod?: string, gameEntry?: string, gameSave?: string[]) {
      this.gameMod = gameMod ?? null;
      this.gameEntry = gameEntry ?? null;
      this.gameSave = gameSave ?? null;
      this.isSplash = false;
    },
    // onLoginDropbox() {
    //   location.href = new DropboxAuth({
    //     clientId: DBX_CLIENT_ID,
    //   }).getAuthenticationUrl(location.href.replace(/\/+$/, ""));
    // },
    // onLogoutDropbox() {
    //   window.localStorage.removeItem("dbx_access_token");
    //   this.isLoginDbx = false;
    // },
    preventBack: function() {
      const thisObject = this;
      history.pushState(null, null, location.href);
      window.onbeforeunload = null;

      window.onpopstate = function() {
        history.go(1);
      };
    },
    onResize() {
      var screenHeight = document.body.clientHeight;
      var screenWidth = document.body.clientWidth;

      if (screenWidth / 640 > screenHeight / 480) {
        this.width = ~~((screenHeight * 640) / 480);
        this.height = screenHeight;
      } else {
        this.width = screenWidth;
        this.height = ~~((screenWidth * 480) / 640);
      }

      // console.log('width : ' + this.width + ', height : ' + this.height);
      // console.log('screenWidth : ' + screenWidth + ', screenHeight : ' + screenHeight);

      var logo = document.getElementById("logo");
      var innerLogo = document.getElementById("innerLogo");
      if (logo != null) {
        if (screenWidth >= screenHeight && screenHeight < 360) {
          logo.style.display = "none";
          innerLogo.style.display = "block";
        } else {
          logo.style.display = "block";
          innerLogo.style.display = "none";
        }
      }
    },
  },
});
</script>
